import { useEffect } from 'react';

import { type CoordinationClientType, useCoordination } from '@atlassiansox/engagekit-ts';

import { useFirePostOfficeTrigger, useTrigger } from '@atlassian/post-office-context';

export const usePostOfficeCoordination = (
	coordinationClient: CoordinationClientType,
	messageId: string,
	poMessageRolloutEnabled?: boolean,
) => {
	const [epMessageStarted, epMessageStop] = useCoordination(coordinationClient, messageId);

	const { isActive: poIsActive } = useTrigger(`${messageId}-started`);
	const { fireTrigger: poRequestMessageStart } = useFirePostOfficeTrigger({
		triggerId: `${messageId}-start`,
	});
	const { fireTrigger: poFireDismissClick } = useFirePostOfficeTrigger({
		triggerId: `${messageId}-dismiss`,
	});

	useEffect(() => {
		if (poMessageRolloutEnabled) {
			poRequestMessageStart({ isActive: true });
		}
	}, [messageId, poMessageRolloutEnabled, poRequestMessageStart]);

	const started = poMessageRolloutEnabled ? poIsActive : epMessageStarted;

	const stop = (force?: boolean) => {
		if (poMessageRolloutEnabled) {
			poFireDismissClick({ isActive: true });
		} else {
			epMessageStop(force);
		}
	};
	return [started, stop] as const;
};
